import { CardElement } from '@stripe/react-stripe-js';

export const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '15px',
      color: '#1a1a1a',
      fontFamily: 'Inter, system-ui, sans-serif',
      '::placeholder': { color: '#9ca3af' },
    },
    invalid: { color: '#dc2626' },
  },
};

// The Stripe CardElement plus its label and inline error. Must be rendered
// inside an <Elements> provider.
export default function CardField({ label = 'Card details', error, onChange }) {
  return (
    <div className="form-field">
      <label>{label}</label>
      <div className="stripe-card-input">
        <CardElement options={CARD_ELEMENT_OPTIONS} onChange={onChange} />
      </div>
      {error ? <span className="field-error">{error}</span> : null}
    </div>
  );
}
